var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6587 12.0051C15.6587 14.0389 14.0235 15.6824 12 15.6824C9.97652 15.6824 8.34141 14.0389 8.34141 12.0051C8.34141 9.97126 9.97652 8.32774 12 8.32774C14.0235 8.32774 15.6587 9.97126 15.6587 12.0051Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5C15.6076 20.5 18.9699 18.3634 21.3102 14.6656C22.2299 13.2172 22.2299 10.7828 21.3102 9.33443C18.9699 5.63655 15.6076 3.5 12 3.5C8.39243 3.5 5.03014 5.63655 2.68983 9.33443C1.77006 10.7828 1.77006 13.2172 2.68983 14.6656C5.03014 18.3634 8.39243 20.5 12 20.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye_on.fd9caff1b54ccefee7910a7cbb4e5925.svg";
export { ForwardRef as ReactComponent };